import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

export function ProtectedRoute({ children }) {
  const hasToken = Cookies.get("token");
  if (!hasToken) {
    return <Navigate to="/login" />;
  }
  return children;
}

export function PublicRoute({ children }) {
  if (Cookies.get("token")) {
    return <Navigate to="/Accueil" />;
  }
  return children;
}

export function RootRedirect() {
  const hasToken = Cookies.get("token");
  return <Navigate to={hasToken ? "/Accueil" : "/login"} />;
}
